import { Playground, Props } from 'docz';
import { Button } from 'bugu-ui';
import BuguBox from "../../../../../src/doc-components/doc-box";
import BasicDemo from "../../../../../src/button/demo/basic.tsx";
import SizeBtn from "../../../../../src/button/demo/size-btn.tsx";
import LoadingButtonDemo from "../../../../../src/button/demo/loading-btn.tsx";
import BasicDemoCode from "!raw-loader!../../../../../src/button/demo/basic.tsx";
import SizeBtnCode from "!raw-loader!../../../../../src/button/demo/size-btn.tsx";
import LoadingButtonDemoCode from "!raw-loader!../../../../../src/button/demo/loading-btn.tsx";
import * as React from 'react';
export default {
  Playground,
  Props,
  Button,
  BuguBox,
  BasicDemo,
  SizeBtn,
  LoadingButtonDemo,
  BasicDemoCode,
  SizeBtnCode,
  LoadingButtonDemoCode,
  React
};